




























import { Component, PropSync, Vue, Prop } from 'vue-property-decorator';

@Component
export default class EmailPreviewDialog extends Vue {
  @PropSync('show') active!: boolean;
  @Prop() messageContent!: string;

  private isMobile = false;

  get isEmpty(): boolean {
    const parser = new DOMParser();
    const content = parser.parseFromString(this.messageContent, 'text/html');
    return content.body.textContent?.trim() === '';
  }
}
